import request, { baseUrl } from '../../_util/sdRequire';

export async function txt2img(params) {
  return request(`/sdapi/v1/txt2img`, {
    method: 'POST',
    data: params,
  });
}
